import * as types from "./actionTypes";

export function beginApiCall() {
  return { type: types.BEGIN_API_CALL };
}

export function beginGroupApiCall() {
  return { type: types.BEGIN_GROUPS_API_CALL };
}